module.exports = __webpack_public_path__ + "img/public.eb36ee5b.svg";